export default class JobOfferSummaryDto {
    workerFullName = '';
    annualSalary = 0;
    expiryDate: Date = new Date();
	description = '';
}